import { useCallback, useEffect, useState } from 'react'
import { PrinterButton } from '../../components/PrinterButton'
import { LogoBase64Image } from '../../constants'
import { ShippingDetailsData } from '../../types/shipping.types'
import { AlertPropsType } from '../../components/ui/alert'
import { fetchShippingDetails } from './ShippingServices'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import moment from 'moment'

type UserState = {
  _id: string;
  full_name: string;
  role: string;
	email: string;
	office: {
		city: string;
		name: string;
		code: string;
		address: string;
	}
};

const PrinterButtonWrapper = ({ shippingData, user }: { shippingData: ShippingDetailsData, user: UserState }) => {
  const receiptData = {
    logoPngBase64: LogoBase64Image,
    officeAddress: user.office.address || "Jl. SM Raja no. 40 Medan",
    shippingNumber: shippingData.shipping_number,
    printDate: moment().format("DD/MM/YYYY, HH:mm:ss"),
    cashier: user.full_name,
    paymentStatus: shippingData.payment_status === "paid" ? "LUNAS" : "BELUM LUNAS",
    items: [
      {
        quantity: shippingData.quantity,
        unit: shippingData.item_unit
      }
    ],
    subtotal: shippingData.total_price,
    discount: shippingData.discount_price,
    totalPayment: shippingData.total_price && shippingData.discount_price ? shippingData.total_price - shippingData.discount_price : shippingData.total_price
  };

  const shippingLabelData = {
    logoPngBase64: LogoBase64Image,
    barcodePngBase64: shippingData.shipping_barcode,
    qrCodePngBase64: shippingData.track_shipping_qrcode,
    branchAddress: user.office.address || "Jl. SM Raja no. 40 Medan",
    trackingNumber: shippingData.shipping_number,
    senderName: shippingData.origin_customer_data.sender_name,
    senderAddress: shippingData.origin_customer_data.sender_address,
    recipientName: shippingData.destination_customer_data.recipient_name,
    recipientAddress: shippingData.destination_customer_data.recipient_address,
    itemCount: shippingData.quantity,
    sendDate: shippingData.shipping_date,
    arrivalDate: shippingData.estimation_arrival_date,
    shippingCost: shippingData.total_price,
    discount: shippingData.discount_price,
    totalPayment: shippingData.total_price && shippingData.discount_price ? shippingData.total_price - shippingData.discount_price : shippingData.total_price,
    paymentStatus: shippingData.payment_status === "paid" ? "LUNAS" : "BELUM LUNAS",
    adminName: user.full_name,
  };


  return (
    <div className='flex items-center justify-between'>
      <PrinterButton
        printType="payment_receipt"
        receipt={receiptData}
        presetIndex={2}
        onPrintError={(error) => console.log(error)}
        buttonLabel="Print Struk Pembayaran"
      />
      <PrinterButton
        printType="shipping_label"
        shippingLabel={shippingLabelData}
        presetIndex={2}
        onPrintError={(error) => console.log(error)}
        buttonLabel="Print Resi Pengiriman"
      />
    </div>
  )
};

const ShippingDetails = ({
  shippingNumber
}: {
  shippingNumber: string | undefined
}) => {
  const { user } = useSelector((state: RootState) => state.auth);

  // const {
  //   _id,
  //   weight_kg,
  //   quantity,
  //   item_unit,
  //   origin_customer_data,
  //   destination_customer_data,
  //   shipping_date,
  //   shipping_number,
  //   status_code,
  //   status_label,
  //   total_price,
  //   payment_status,
  //   origin_office_id,
  //   destination_office_id
  // } = shippingData;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [alert, setAlert] = useState<AlertPropsType | null>(null);

  const [shippingData, setShippingData] = useState<ShippingDetailsData | null>(null);

  const getShippingDetails = useCallback(async (shippingCode: string) => {
    try {
      const response = await fetchShippingDetails(shippingCode);
      const { status, message, data } = response;
      if (status === 200) {
        setShippingData(data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setAlert({
          variant: "error",
          title: "Terjadi kesalahan",
          message
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
      setAlert({
        variant: "error",
        title: "Terjadi kesalahan",
        message: "Silahkan coba beberapa saat lagi"
      });
    }
  }, []);

  useEffect(() => {
    if (shippingNumber) {
      getShippingDetails(shippingNumber)
    };

    return () => { }
  }, [shippingNumber, getShippingDetails]);

  return (
    <div className='pt-4'>
      {shippingData && user && 
        <PrinterButtonWrapper shippingData={shippingData} user={user} />
      }
    </div>
  )
}

export default ShippingDetails